import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Card,
  CardContent,
  Grid,
  Tooltip,
  TableFooter,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Alert,
  TablePagination,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  LinearProgress,
  Snackbar,
  CardHeader,
  TableSortLabel,
  SelectChangeEvent,
  Container,
  Input,
  OutlinedInput,
  InputBase,
  Tab,
  Tabs,
} from "@mui/material";
import {
  Search,
  Close,
  Person,
  Payment,
  Receipt,
  AccountBalance,
  Warning,
  ArrowForward,
  Visibility,
  CheckCircle,
  AttachMoney,
  Description,
  AttachFile,
  ZoomIn,
  FilterList,
  Download,
  ExpandMore,
  ExpandLess,
  Refresh,
  Info as InfoIcon,
  Error as ErrorIcon,
  LocalShipping,
  Store,
  Category,
  Inventory,
  AccountCircle,
  Phone,
  Email,
  LocationOn,
  CreditCard,
  MonetizationOn,
  TrendingUp,
  TrendingDown,
  CalendarToday,
  AccessTime,
  Print,
  Share,
  MoreVert,
  ArrowDropDown,
  ArrowDropUp,
  BarChart,
  PieChart,
  ShowChart,
  Assessment,
  Dashboard,
  ViewList,
  ViewModule,
  ViewCompact,
  FilterAlt,
  Sort,
  Tune,
  ClearAll,
  SaveAlt,
  PictureAsPdf,
  GridView,
  ListAlt,
  TableChart,
  Add,
  Remove,
  Delete,
  Edit,
  ContentCopy,
  FileCopy,
  GetApp,
  Upload,
  CloudUpload,
  CloudDownload,
  Sync,
  Autorenew,
  Cached,
  RotateLeft,
  RotateRight,
  ZoomOut,
  Fullscreen,
  FullscreenExit,
  OpenInNew,
  Launch,
  Link,
  InsertLink,
  InsertPhoto,
  InsertDriveFile,
  Attachment,
  Cloud,
  Storage,
  Database,
  DataUsage,
  Memory,
  DeveloperBoard,
  IntegrationInstructions,
  Api,
  Web,
  Android,
  Apple,
  Windows,
  Linux,
  Devices,
  Computer,
  Laptop,
  Tablet,
  PhoneAndroid,
  PhoneIphone,
  Smartphone,
  Watch,
  Headset,
  Keyboard,
  Mouse,
  Speaker,
  Tv,
  CameraAlt,
  Videocam,
  Mic,
  Headphones,
  Power,
  BatteryFull,
  BatteryChargingFull,
  BatteryStd,
  BatteryUnknown,
  BatteryAlert,
  BatteryVeryLow,
  BatteryLow,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  BatterySaver,
  PowerOff,
  PowerSettingsNew,
  RestartAlt,
  Settings,
  SettingsApplications,
  SettingsBackupRestore,
  SettingsBluetooth,
  SettingsBrightness,
  SettingsCell,
  SettingsEthernet,
  SettingsInputAntenna,
  SettingsInputComponent,
  SettingsInputComposite,
  SettingsInputHdmi,
  SettingsInputSvideo,
  SettingsOverscan,
  SettingsPhone,
  SettingsRemote,
  SettingsVoice,
  Build,
  BuildCircle,
  Engineering,
  Handyman,
  Plumbing,
  ElectricalServices,
  Carpenter,
  Paid,
  MoneyOff,
} from "@mui/icons-material";
import { formatCurrencyN } from "../../../common/utils_t";
import {
  getAllCustomers2,
  getCustomersWithPendingTransactions,
} from "../../../api/customers/customers";
import { IonApp, IonButton, IonContent, IonPage } from "@ionic/react";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { fetchSalesData_withdate_staffId_paymentMethodCall, getManagersOrders_reciept, getManagersOrders_reciept_withdate, getOrderTransaction, verifyTransaction, fetchOrderDetails_items } from "../../../api/reports/reports";
import { getStaffList_saleapp } from "../../../api/users/user";
import { baseUrl, config, requestID } from "../../../common/utils";
import { MenuButton } from "../../../components/Menu";
import axios from "axios";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface Customer {
  id: string;
  user_id: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  grade_letter: string;
}

interface PendingTransactionSummary {
  customer_id: string;
  total_outstanding: number;
  transaction_count: number;
  customer: Customer;
  member_name: string;
  customer_phone: string;
  customer_email: string;
  balance_due: number;
  // ADD TRANSACTION FIELDS HERE
  order_id?: string;
  order_code?: string;
  order_date?: string;
  mode_of_payment?: string;
  payable_amount?: string;
  amount_paid?: string;
  order_status?: string;
  product_id_type?: string;
  is_verified?: number;
  is_audited?: number;
  // Additional fields for verification dialog
  customer_name?: string;
  customer_account_name?: string;
  customer_account_number?: string;
  bank_name?: string;
  active_status?: string;
  staff_name?: string;
  mode_of_payment_real?: string;
  card_amount?: string;
  rmbValue?: string;
  cryptoType?: string;
  cryptoAmount?: string;
  costPrice?: string;
  sellingPrice?: string;
  commission?: string;
  external_processor?: string;
  processor_type?: string;
  processor_category?: string;
  load_type?: string;
  card_rate?: string;
  naira_rate?: string;
  internal_rate?: string;
  created_at?: string;
  last_updated?: string;
  proof_of_payment?: string;
  proof_of_jobstart?: string;
  crypto_value?: string;
  images?: string[];
  screenshot?: string;
  transaction_proof?: string;
  branch_id?: string;
  order_by?: string;
  giftcardType?: string;
  cardUnit?: number;
  payment_status?: number;
  member_id?: string;
  phone?: string;
  email?: string;
}

interface OrderItem {
  product_id: string;
  quantity: string;
  product_name: string;
  price: string;
  total_amount: string;
  item_status: string;
  name?: string;
  description?: string;
  category_id?: string;
  cost_price?: string;
  status?: string;
  business_id?: string;
}

interface SalesStats {
  total_sales: number;
  total_orders: number;
  average_order_value: number;
  top_payment_method: string;
  growth_percentage: number;
  pending_orders: number;
  completed_orders: number;
}

interface Staff {
  staff_id: string;
  staff_name: string;
  user_id: string;
  firstName: string;
  lastName: string;
}

interface FilterState {
  startDate: Date | null;
  endDate: Date | null;
  paymentMethod: string;
  department: string;
  orderStatus: string;
  paymentStatus: string;
  staffId: string;
  productType: string;
}

// Interface for Order Details Response
interface OrderDetailsResponse {
  success: boolean;
  data: {
    order_id: string;
    order_code: string;
    order_date: string;
    items: OrderItem[];
    subtotal: number;
    tax: number;
    discount: number;
    total: number;
    payment_method: string;
    staff_name: string;
    customer_name: string;
    date_range?: {
      applied: boolean;
      start_date: string;
      end_date: string;
    };
  };
  message?: string;
  status?: boolean;
}

// Interface for the new API response structure
interface OnlineBookingResponse {
  status: boolean;
  message: string;
  data: {
    paid_orders: Array<{
      order: any;
      order_id: string;
      order_code: string;
      order_date: string;
      mode_of_payment: string;
      payable_amount: string;
      balance_due: string;
      order_by: string;
      order_status: string;
      member_id: string;
      phone: string;
      email: string;
      member_name: string;
      payment_status: number;
      otp_status: string | null;
      branch_id: string;
      business_id: string;
      amount_paid: string;
      sellingPrice: string;
      costPrice: string;
      commission: string;
      processor_type: string | null;
      external_processor: string | null;
      customer_name: string | null;
      customer_email: string;
      customer_phone: string;
      customer_account_name: string | null;
      customer_account_number: string | null;
      customer_bank_code: string | null;
      product_id: string;
      product_name: string | null;
      product_type: string;
      naira_rate: string | null;
      card_rate: string | null;
      card_amount: string | null;
      rmbValue: string;
      load_type: string | null;
      proof_of_payment: string;
      approved_by: string | null;
      last_updated: string;
      deleted_at: string | null;
      updated_at: string | null;
      created_at: string;
      cryptoAmount: string | null;
      cryptoType: string;
      product_id_type: string;
      staff_name: string;
      bank_name: string | null;
      cardUnit: string;
      cardValue: string;
      unitPrice: string;
      items: any[];
    }>;
    notpaid_orders: Array<{
      order: any;
      order_id: string;
      order_code: string;
      order_date: string;
      mode_of_payment: string;
      payable_amount: string;
      balance_due: string;
      order_by: string;
      order_status: string;
      member_id: string;
      phone: string;
      email: string;
      member_name: string;
      payment_status: number;
      otp_status: string | null;
      branch_id: string;
      business_id: string;
      amount_paid: string | null;
      sellingPrice: string;
      costPrice: string;
      commission: string;
      processor_type: string | null;
      external_processor: string | null;
      customer_name: string | null;
      customer_email: string;
      customer_phone: string;
      customer_account_name: string | null;
      customer_account_number: string | null;
      customer_bank_code: string | null;
      product_id: string;
      product_name: string | null;
      product_type: string;
      naira_rate: string | null;
      card_rate: string | null;
      card_amount: string | null;
      rmbValue: string;
      load_type: string | null;
      proof_of_payment: string;
      approved_by: string | null;
      last_updated: string;
      deleted_at: string | null;
      updated_at: string | null;
      created_at: string;
      cryptoAmount: string | null;
      cryptoType: string;
      product_id_type: string;
      staff_name: string;
      bank_name: string | null;
      cardUnit: string;
      cardValue: string;
      unitPrice: string;
      items: any[];
    }>;
    balance: number | null;
  };
}

const ManageOnlineBooking: React.FC = () => {
  const history = useHistory();
  const [tabValue, setTabValue] = useState(0);
  const [paidOrders, setPaidOrders] = useState<PendingTransactionSummary[]>([]);
  const [unpaidOrders, setUnpaidOrders] = useState<PendingTransactionSummary[]>([]);
  const [filteredPaidOrders, setFilteredPaidOrders] = useState<PendingTransactionSummary[]>([]);
  const [filteredUnpaidOrders, setFilteredUnpaidOrders] = useState<PendingTransactionSummary[]>([]);
  const [loading, setLoading] = useState({
    customers: false,
    pending: false,
    paid: false,
    unpaid: false,
  });
  const [searchQuery, setSearchQuery] = useState("");

  // NEW STATE VARIABLES FOR DIALOG AND FILTERS
  const [showFilters, setShowFilters] = useState(false);
  const [verifyDialogOpen, setVerifyDialogOpen] = useState(false);
  const [transactionToVerify, setTransactionToVerify] = useState<PendingTransactionSummary | null>(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const [verifyDialogLoading, setVerifyDialogLoading] = useState(false);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  // NEW STATE FOR AUTO REFRESH
  const [isAutoRefreshing, setIsAutoRefreshing] = useState(false);
  const [lastRefreshTime, setLastRefreshTime] = useState<Date>(new Date());
  const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(true);
  const [refreshCount, setRefreshCount] = useState(0);

  // NEW STATE FOR ORDER DETAILS DIALOG (from second component)
  const [showTransactionDetail, setShowTransactionDetail] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState<PendingTransactionSummary | null>(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [orderDetails, setOrderDetails] = useState<OrderDetailsResponse['data'] | null>(null);
  const [detailsError, setDetailsError] = useState<string | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const [staffList, setStaffList] = useState<Staff[]>([]);
  const [filters, setFilters] = useState<FilterState>({
    startDate: dayjs().toDate(),
    endDate: dayjs().toDate(),
    paymentMethod: "",
    department: "",
    orderStatus: "",
    paymentStatus: "",
    staffId: "",
    productType: "",
  });

  const paymentMethods = ["All", "manual_transfer", "auto_transfer"];
  const orderStatuses = ["All", "COMPLETED", "PENDING", "CANCELLED"];
  const paymentStatuses = ["All", "0", "1", "2"];

  // Use refs to prevent stale closures in intervals
  const autoRefreshEnabledRef = useRef(autoRefreshEnabled);
  const verifyDialogOpenRef = useRef(verifyDialogOpen);


  const getCustomerOnlineBooking = async () => {
    const data = {
      requestID: requestID(),
      //customer_id:id
    };
    try {
      const response = await axios.post(
        baseUrl() + "orderhistorys/getCustomerOnlineBooking",
        data,
        config
      );
      console.log({ response })
      console.log(response.data)

      return response.data

    } catch (error: any) {
      return error
    }

  }


  // Update refs when state changes
  useEffect(() => {
    autoRefreshEnabledRef.current = autoRefreshEnabled;
    verifyDialogOpenRef.current = verifyDialogOpen;
  }, [autoRefreshEnabled, verifyDialogOpen]);

  // Fetch all data on component mount
  useEffect(() => {
    fetchAllCustomers();
    fetchOnlineBookings();
    fetchStaffData();

    // Set up auto-refresh
    const intervalId = setInterval(() => {
      // Only refresh if auto-refresh is enabled AND no dialog is open
      if (autoRefreshEnabledRef.current && !verifyDialogOpenRef.current) {
        fetchOnlineBookingsQuietly();
      }
    }, 300000); // 5 minutes

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  // Apply filters when search or filters change
  useEffect(() => {
    applyFilters();
  }, [searchQuery, filters, paidOrders, unpaidOrders, tabValue]);

  // Fetch all customers
  const fetchAllCustomers = async () => {
    try {
      setLoading((prev) => ({ ...prev, customers: true }));
      const response = await getAllCustomers2();
      // setAllCustomers(response.data);
    } catch (error) {
      console.error("Error fetching all customers:", error);
    } finally {
      setLoading((prev) => ({ ...prev, customers: false }));
    }
  };

  // Main fetch function for online bookings
  const fetchOnlineBookings = async () => {
    try {
      setLoading((prev) => ({ ...prev, paid: true, unpaid: true }));
      const response = await getCustomerOnlineBooking() as OnlineBookingResponse;
      console.log("Fetched online bookings:", response.data);

      // Transform paid orders
      const transformedPaidOrders = response.data.paid_orders.map((item: any) => ({
        ...item,
        order_id: item.order_id || item.transaction_id || "",
        order_code: item.order_code || "N/A",
        order_date: item.order_date || item.created_at || "",
        mode_of_payment: item.mode_of_payment || "N/A",
        payable_amount: item.payable_amount || "0",
        amount_paid: item.amount_paid || "0",
        order_status: item.order_status || "COMPLETED",
        product_id_type: item.product_id_type || "N/A",
        is_verified: item.is_verified || 0,
        is_audited: item.is_audited || 0,
        customer_name: item.member_name || "",
        customer_phone: item.phone || item.customer_phone || "",
        customer_email: item.email || item.customer_email || "",
        member_name: item.member_name || "",
        member_id: item.member_id || "",
        phone: item.phone || item.customer_phone || "",
        email: item.email || item.customer_email || "",
        balance_due: item.balance_due || "0",
        branch_id: item.branch_id || "",
      }));

      // Transform unpaid orders
      const transformedUnpaidOrders = response.data.notpaid_orders.map((item: any) => ({
        ...item,
        order_id: item.order_id || item.transaction_id || "",
        order_code: item.order_code || "N/A",
        order_date: item.order_date || item.created_at || "",
        mode_of_payment: item.mode_of_payment || "N/A",
        payable_amount: item.payable_amount || "0",
        amount_paid: item.amount_paid || "0",
        order_status: item.order_status || "PENDING",
        product_id_type: item.product_id_type || "N/A",
        is_verified: item.is_verified || 0,
        is_audited: item.is_audited || 0,
        customer_name: item.member_name || "",
        customer_phone: item.phone || item.customer_phone || "",
        customer_email: item.email || item.customer_email || "",
        member_name: item.member_name || "",
        member_id: item.member_id || "",
        phone: item.phone || item.customer_phone || "",
        email: item.email || item.customer_email || "",
        balance_due: item.balance_due || "0",
        branch_id: item.branch_id || "",
      }));

      setPaidOrders(transformedPaidOrders);
      setUnpaidOrders(transformedUnpaidOrders);
      setFilteredPaidOrders(transformedPaidOrders);
      setFilteredUnpaidOrders(transformedUnpaidOrders);
      setLastRefreshTime(new Date());
    } catch (error) {
      console.error("Error fetching online bookings:", error);
    } finally {
      setLoading((prev) => ({ ...prev, paid: false, unpaid: false }));
    }
  };

  // Quiet fetch function - for auto-refresh (no loading indicators)
  const fetchOnlineBookingsQuietly = async () => {
    // Skip if already refreshing or dialog is open
    if (isAutoRefreshing || verifyDialogOpenRef.current) return;

    try {
      setIsAutoRefreshing(true);
      const response = await getCustomerOnlineBooking() as OnlineBookingResponse;
      console.log("Auto-refreshed online bookings:", response.data);

      // Transform paid orders
      const transformedPaidOrders = response.data.paid_orders.map((item: any) => ({
        ...item,
        order_id: item.order_id || item.transaction_id || "",
        order_code: item.order_code || "N/A",
        order_date: item.order_date || item.created_at || "",
        mode_of_payment: item.mode_of_payment || "N/A",
        payable_amount: item.payable_amount || "0",
        amount_paid: item.amount_paid || "0",
        order_status: item.order_status || "COMPLETED",
        product_id_type: item.product_id_type || "N/A",
        is_verified: item.is_verified || 0,
        is_audited: item.is_audited || 0,
        customer_name: item.member_name || "",
        customer_phone: item.phone || item.customer_phone || "",
        customer_email: item.email || item.customer_email || "",
        member_name: item.member_name || "",
        member_id: item.member_id || "",
        phone: item.phone || item.customer_phone || "",
        email: item.email || item.customer_email || "",
        balance_due: item.balance_due || "0",
        branch_id: item.branch_id || "",
      }));

      // Transform unpaid orders
      const transformedUnpaidOrders = response.data.notpaid_orders.map((item: any) => ({
        ...item,
        order_id: item.order_id || item.transaction_id || "",
        order_code: item.order_code || "N/A",
        order_date: item.order_date || item.created_at || "",
        mode_of_payment: item.mode_of_payment || "N/A",
        payable_amount: item.payable_amount || "0",
        amount_paid: item.amount_paid || "0",
        order_status: item.order_status || "PENDING",
        product_id_type: item.product_id_type || "N/A",
        is_verified: item.is_verified || 0,
        is_audited: item.is_audited || 0,
        customer_name: item.member_name || "",
        customer_phone: item.phone || item.customer_phone || "",
        customer_email: item.email || item.customer_email || "",
        member_name: item.member_name || "",
        member_id: item.member_id || "",
        phone: item.phone || item.customer_phone || "",
        email: item.email || item.customer_email || "",
        balance_due: item.balance_due || "0",
        branch_id: item.branch_id || "",
      }));

      setPaidOrders(transformedPaidOrders);
      setUnpaidOrders(transformedUnpaidOrders);
      setFilteredPaidOrders(transformedPaidOrders);
      setFilteredUnpaidOrders(transformedUnpaidOrders);
      setLastRefreshTime(new Date());
      setRefreshCount(prev => prev + 1);
    } catch (error) {
      console.error("Error during auto-refresh:", error);
    } finally {
      setIsAutoRefreshing(false);
    }
  };

  // Fetch staff data
  const fetchStaffData = async () => {
    try {
      const response = await getStaffList_saleapp();
      console.log({ staffResponse: response });
      if (response.data) {
        setStaffList(response.data);
      }
    } catch (error) {
      console.error("Error fetching staff data:", error);
    }
  };

  // NEW FUNCTION: Fetch order details from API endpoint
  const fetchOrderDetails = async (orderId: string, branchId?: string) => {
    setLoadingDetails(true);
    setDetailsError(null);
    setOrderDetails(null);

    try {
      console.log("Fetching order details for:", {
        order_id: orderId,
        branch_id: branchId
      });

      const response = await fetchOrderDetails_items(orderId, "", "", branchId || "");
      console.log({ response });

      if (response.status) {
        setOrderDetails(response.data);
        setSnackbarMessage("Order details loaded successfully");
        setSnackbarOpen(true);
      } else {
        throw new Error(response.message || "Failed to load order details");
      }

    } catch (error) {
      console.error("Error fetching order details:", error);
      setDetailsError(error instanceof Error ? error.message : "Failed to load order details");
      setSnackbarMessage("Failed to load order details");
      setSnackbarOpen(true);
    } finally {
      setLoadingDetails(false);
    }
  };

  // MODIFIED: Update viewTransactionDetail to fetch order details
  const viewTransactionDetail = async (transaction: PendingTransactionSummary) => {
    console.log("transaction", transaction);
    setSelectedTransaction(transaction);
    setShowTransactionDetail(true);

    // Fetch order details when dialog opens
    await fetchOrderDetails(transaction.order_id || "", transaction.branch_id);
  };

  // NEW: Close dialog and reset details
  const closeTransactionDetail = () => {
    setShowTransactionDetail(false);
    setSelectedTransaction(null);
    setOrderDetails(null);
    setDetailsError(null);
  };

  // Filter transactions based on current tab
  const applyFilters = () => {
    let filteredPaid = paidOrders || [];
    let filteredUnpaid = unpaidOrders || [];

    // Apply search filter to both tabs
    if (searchQuery) {
      const searchLower = searchQuery.toLowerCase();

      filteredPaid = filteredPaid?.filter(
        (transaction) =>
          transaction?.order_code?.toLowerCase().includes(searchLower) ||
          transaction?.member_name?.toLowerCase().includes(searchLower) ||
          transaction?.phone?.toLowerCase().includes(searchLower) ||
          transaction?.email?.toLowerCase().includes(searchLower)
      );

      filteredUnpaid = filteredUnpaid?.filter(
        (transaction) =>
          transaction?.order_code?.toLowerCase().includes(searchLower) ||
          transaction?.member_name?.toLowerCase().includes(searchLower) ||
          transaction?.phone?.toLowerCase().includes(searchLower) ||
          transaction?.email?.toLowerCase().includes(searchLower)
      );
    }

    // Apply date filter
    if (filters.startDate && filters.endDate) {
      const start = new Date(filters.startDate);
      start.setHours(0, 0, 0, 0);

      const end = new Date(filters.endDate);
      end.setHours(23, 59, 59, 999);

      filteredPaid = filteredPaid?.filter((transaction) => {
        if (!transaction?.order_date) return false;
        const transactionDate = new Date(transaction.order_date);
        return transactionDate >= start && transactionDate <= end;
      });

      filteredUnpaid = filteredUnpaid?.filter((transaction) => {
        if (!transaction?.order_date) return false;
        const transactionDate = new Date(transaction.order_date);
        return transactionDate >= start && transactionDate <= end;
      });
    }

    // Apply payment method filter
    if (filters.paymentMethod && filters.paymentMethod !== "All") {
      filteredPaid = filteredPaid?.filter(
        (transaction) => transaction?.mode_of_payment === filters.paymentMethod
      );
      filteredUnpaid = filteredUnpaid?.filter(
        (transaction) => transaction?.mode_of_payment === filters.paymentMethod
      );
    }

    // Apply staff filter
    if (filters.staffId && filters.staffId !== "All") {
      filteredPaid = filteredPaid?.filter((transaction) => transaction?.order_by === filters.staffId);
      filteredUnpaid = filteredUnpaid?.filter((transaction) => transaction?.order_by === filters.staffId);
    }

    setFilteredPaidOrders(filteredPaid);
    setFilteredUnpaidOrders(filteredUnpaid);
  };

  const handleFilterChange = (field: keyof FilterState, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const clearFilters = () => {
    setFilters({
      startDate: dayjs().toDate(),
      endDate: dayjs().toDate(),
      paymentMethod: "",
      department: "",
      orderStatus: "",
      paymentStatus: "",
      staffId: "",
      productType: "",
    });
    setSearchQuery("");
  };

  // Toggle auto-refresh
  const toggleAutoRefresh = () => {
    setAutoRefreshEnabled(prev => !prev);
  };

  // Manual refresh function
  const handleManualRefresh = () => {
    fetchOnlineBookings();
  };

  // Handle tab change
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Verification dialog functions
  const handleVerifyClick = async (transaction: PendingTransactionSummary) => {
    setVerifyDialogOpen(true);
    setVerifyDialogLoading(true);

    try {
      // First, get full transaction details
      const transactionToFetch = {
        order_code: transaction.order_code,
        order_id: transaction.order_id,
        member_id: transaction.customer_id,
      };

      const response = await getOrderTransaction(transactionToFetch);
      console.log("Transaction details:", response.data);

      if (response.status) {
        // Merge the fetched details with the existing transaction
        setTransactionToVerify({
          ...transaction,
          ...response.data
        });
      } else {
        // If API fails, use the basic transaction data
        setTransactionToVerify(transaction);
      }
    } catch (error) {
      console.error("Error fetching transaction details:", error);
      // Use the basic transaction data if API fails
      setTransactionToVerify(transaction);
    } finally {
      setTimeout(() => {
        setVerifyDialogLoading(false);
      }, 500);
    }
  };

  const handleVerifyTransaction = async () => {
    if (!transactionToVerify) return;
    console.log(transactionToVerify.order_code);
    setIsVerifying(true);
    try {
      const response = await verifyTransaction(transactionToVerify);
      // Refresh the data after verification
      fetchOnlineBookings();
    } catch (error) {
      console.error("Error verifying transaction:", error);
      alert("An error occurred during verification.");
    } finally {
      setIsVerifying(false);
      setVerifyDialogOpen(false);
      setTransactionToVerify(null);
    }
  };

  const handleImageClick = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setImageDialogOpen(true);
  };

  const getOrderStatusColor = (status: string) => {
    if (!status) return "default";
    switch (status.toUpperCase()) {
      case "COMPLETED":
        return "success";
      case "PENDING":
        return "warning";
      case "CANCELLED":
        return "error";
      default:
        return "default";
    }
  };

  const getPaymentStatusLabel = (status: string) => {
    switch (status) {
      case "0":
        return "Unpaid";
      case "1":
        return "Paid";
      case "2":
        return "Partial";
      default:
        return "Unknown";
    }
  };

  const getPaymentStatusColor = (status: string) => {
    switch (status) {
      case "0":
        return "error";
      case "1":
        return "success";
      case "2":
        return "warning";
      default:
        return "default";
    }
  };

  const formatCurrency = (amount: string | number) => {
    const numAmount = typeof amount === "string" ? Number.parseFloat(amount) : amount;
    if (isNaN(numAmount)) return "₦0.00";
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(numAmount);
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "Invalid Date";
    try {
      return new Date(dateString).toLocaleDateString("en-NG", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      return "Invalid Date";
    }
  };

  const formatTimeAgo = (date: Date) => {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffSec = Math.floor(diffMs / 1000);

    if (diffSec < 60) return `${diffSec} seconds ago`;
    if (diffSec < 3600) return `${Math.floor(diffSec / 60)} minutes ago`;
    return `${Math.floor(diffSec / 3600)} hours ago`;
  };

  const handleCustomerSelect = (selectedCustomer: PendingTransactionSummary) => {
    const selectedCustomerx: Customer = {
      id: selectedCustomer.member_id || selectedCustomer.customer_id || "",
      user_id: selectedCustomer.member_id || selectedCustomer.customer_id || "",
      firstName: selectedCustomer.member_name || "",
      lastName: "",
      phone: selectedCustomer.phone || selectedCustomer.customer_phone || "",
      email: selectedCustomer.email || selectedCustomer.customer_email || "",
      grade_letter: "A",
    };
    console.log("Selected customer:", selectedCustomerx);

    history.push("/folder/raise-receipt/:name", { customer: selectedCustomerx });
  };

  const handleViewAllCustomers = () => {
    history.push("/folder/customer-accounts-giftcard-crypto");
  };

  const getOutstandingColor = (amount: number) => {
    if (amount > 50000) return "error";
    if (amount > 20000) return "warning";
    return "primary";
  };

  const getOutstandingColor2 = (amount: number) => {
    if (amount > 1) return "error";
    if (amount > 1) return "warning";
    return "error";
  };

  // Calculate totals for current tab
  const currentOrders = tabValue === 0 ? filteredPaidOrders : filteredUnpaidOrders;
  const totalOutstanding = currentOrders.reduce(
    (sum, item) => sum + Number(item.balance_due || 0),
    0
  );
  const totalOrders = currentOrders.length;
  const totalAmount = currentOrders.reduce(
    (sum, item) => sum + Number(item.payable_amount || 0),
    0
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <IonPage className="pushDown">
        <MenuButton />

        <IonContent>
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h4" gutterBottom>
                Online Room Bookings
              </Typography>

              {/* Auto-refresh indicator and controls */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  {autoRefreshEnabled ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <CircularProgress size={12} />
                      <span>Auto-refresh enabled</span>
                    </Box>
                  ) : (
                    "Auto-refresh paused"
                  )}
                </Typography>

                <Tooltip title={autoRefreshEnabled ? "Pause auto-refresh" : "Enable auto-refresh"}>
                  <IconButton
                    size="small"
                    onClick={toggleAutoRefresh}
                    color={autoRefreshEnabled ? "primary" : "default"}
                  >
                    <Refresh />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Refresh now">
                  <IconButton
                    size="small"
                    onClick={handleManualRefresh}
                    disabled={loading.paid || loading.unpaid}
                  >
                    {(loading.paid || loading.unpaid) ? <CircularProgress size={20} /> : <Refresh />}
                  </IconButton>
                </Tooltip>

                <Typography variant="caption" color="text.secondary">
                  Last updated: {formatTimeAgo(lastRefreshTime)}
                </Typography>
              </Box>
            </Box>

            {/* Summary Cards */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={4}>
                <Card sx={{ bgcolor: tabValue === 0 ? "success.light" : "warning.light" }}>
                  <CardContent sx={{ textAlign: "center" }}>
                    {tabValue === 0 ? (
                      <Paid sx={{ fontSize: 40, mb: 1 }} />
                    ) : (
                      <MoneyOff sx={{ fontSize: 40, mb: 1 }} />
                    )}
                    <Typography variant="h6">
                      {tabValue === 0 ? "Paid Bookings" : "Unpaid Bookings"}
                    </Typography>
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {totalOrders}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card sx={{ bgcolor: "info.light" }}>
                  <CardContent sx={{ textAlign: "center" }}>
                    <AttachMoney sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6">Total Amount</Typography>
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {formatCurrencyN(totalAmount)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card sx={{ bgcolor: tabValue === 0 ? "primary.light" : "error.light" }}>
                  <CardContent sx={{ textAlign: "center" }}>
                    {tabValue === 0 ? (
                      <CheckCircle sx={{ fontSize: 40, mb: 1 }} />
                    ) : (
                      <Warning sx={{ fontSize: 40, mb: 1 }} />
                    )}
                    <Typography variant="h6">
                      {tabValue === 0 ? "Completed" : "Outstanding Balance"}
                    </Typography>
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {tabValue === 0 ? "PAID" : formatCurrencyN(totalOutstanding)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Tabs */}
            <Paper sx={{ mb: 2 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="booking tabs"
                sx={{ borderBottom: 1, borderColor: 'divider' }}
              >
                <Tab
                  icon={<Paid />}
                  iconPosition="start"
                  label={`Paid Bookings (${filteredPaidOrders.length})`}
                  {...a11yProps(0)}
                />
                <Tab
                  icon={<MoneyOff />}
                  iconPosition="start"
                  label={`Unpaid Bookings (${filteredUnpaidOrders.length})`}
                  {...a11yProps(1)}
                />
              </Tabs>
            </Paper>

            {/* Search and Actions */}
            <Paper sx={{ p: 2, mb: 2 }}>
              <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2, flexWrap: "wrap" }}>
                <TextField
                  placeholder="Search by order code, customer name, phone, or email..."
                  variant="outlined"
                  size="small"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: 300 }}
                />

                <Button
                  variant="outlined"
                  startIcon={<FilterList />}
                  onClick={() => setShowFilters(!showFilters)}
                >
                  Filters
                </Button>

                <Box sx={{ flexGrow: 1 }} />

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {isAutoRefreshing && (
                    <CircularProgress size={16} />
                  )}
                  <Typography variant="body2" color="text.secondary">
                    Showing {currentOrders.length} of {tabValue === 0 ? paidOrders.length : unpaidOrders.length} {tabValue === 0 ? "paid" : "unpaid"} bookings
                    {refreshCount > 0 && ` • Auto-refreshed ${refreshCount} times`}
                  </Typography>
                </Box>
              </Box>

              {/* Filter Panel */}
              {showFilters && (
                <Box sx={{ borderTop: 1, borderColor: "divider", pt: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <DatePicker
                        label="Start Date"
                        value={dayjs(filters.startDate)}
                        onChange={(date) => {
                          const dateValue = date ? date.toDate() : null;
                          handleFilterChange("startDate", dateValue);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <DatePicker
                        label="End Date"
                        value={dayjs(filters.endDate)}
                        onChange={(date) => {
                          const dateValue = date ? date.toDate() : null;
                          handleFilterChange("endDate", dateValue);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={clearFilters}
                        fullWidth
                      >
                        Clear Filters
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Paper>

            {/* Tab Panels */}
            <TabPanel value={tabValue} index={0}>
              {/* Paid Bookings Table */}
              <TableContainer
                component={Paper}
                sx={{
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    height: 8,
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f1f1f1",
                    borderRadius: 4,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#c1c1c1",
                    borderRadius: 4,
                    "&:hover": {
                      backgroundColor: "#a8a8a8",
                    },
                  },
                }}
              >
                <Table sx={{ minWidth: 1400 }}>
                  <TableHead>
                    <TableRow sx={{ bgcolor: "success.light" }}>
                      <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Customer</TableCell>
                      <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Order Code</TableCell>
                      <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Date</TableCell>
                      <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Payment Method</TableCell>
                      <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                        Amount Paid
                      </TableCell>
                      <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                        Payable Amount
                      </TableCell>
                      <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Status</TableCell>
                      <TableCell align="center" sx={{ minWidth: 200, whiteSpace: "nowrap" }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading.paid ? (
                      <TableRow>
                        <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : filteredPaidOrders.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                          <Typography variant="body1" color="text.secondary">
                            {searchQuery ? "No paid bookings found matching your search" : "No paid bookings found"}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <React.Fragment>
                        {filteredPaidOrders.map((transaction) => (
                          <TableRow
                            key={transaction.order_id || transaction.customer_id}
                            sx={{
                              "&:nth-of-type(even)": { bgcolor: "grey.50" },
                              "&:hover": { bgcolor: "action.hover" },
                            }}
                          >
                            {/* Customer Column */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Avatar
                                  sx={{ bgcolor: "#e3f2fd", width: 40, height: 40, mr: 2 }}
                                >
                                  <Person sx={{ fontSize: 20, color: "#1976d2" }} />
                                </Avatar>
                                <Box>
                                  <Typography variant="body2" fontWeight="500">
                                    {transaction.member_name}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {transaction.email || "No email"}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" display="block">
                                    {transaction.phone}
                                  </Typography>
                                </Box>
                              </Box>
                            </TableCell>

                            {/* Order Code */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2" sx={{ fontWeight: "bold", color: "primary.main" }}>
                                {transaction.order_code || "N/A"}
                              </Typography>
                            </TableCell>

                            {/* Date */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2">
                                {transaction.order_date ? formatDate(transaction.order_date) : "N/A"}
                              </Typography>
                            </TableCell>

                            {/* Payment Method */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Chip
                                label={transaction.mode_of_payment || "N/A"}
                                size="small"
                                color="secondary"
                              />
                            </TableCell>

                            {/* Amount Paid */}
                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2" sx={{ fontWeight: "bold", color: "success.main" }}>
                                {formatCurrency(transaction.amount_paid || "0")}
                              </Typography>
                            </TableCell>

                            {/* Payable Amount */}
                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2">
                                {formatCurrency(transaction.payable_amount || "0")}
                              </Typography>
                            </TableCell>

                            {/* Status */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                <Chip
                                  label="PAID"
                                  size="small"
                                  color="success"
                                  sx={{ width: "fit-content" }}
                                />
                                {transaction.is_verified === 1 && (
                                  <Chip
                                    label="Verified"
                                    size="small"
                                    color="success"
                                    sx={{ width: "fit-content" }}
                                  />
                                )}
                              </Box>
                            </TableCell>

                            {/* Actions */}
                            <TableCell align="center">
                              <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                                <Tooltip title="View Order Details">
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color="info"
                                    startIcon={<Visibility />}
                                    onClick={() => viewTransactionDetail(transaction)}
                                  >
                                    View
                                  </Button>
                                </Tooltip>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}

                        {/* Footer with Totals */}
                        <TableRow sx={{ backgroundColor: "grey.200" }}>
                          <TableCell colSpan={4} align="right">
                            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                              Totals
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1" sx={{ fontWeight: "bold", color: "success.main" }}>
                              {formatCurrency(
                                filteredPaidOrders.reduce(
                                  (sum, tx) => sum + Number(tx.amount_paid || 0),
                                  0
                                )
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                              {formatCurrency(
                                filteredPaidOrders.reduce(
                                  (sum, tx) => sum + Number(tx.payable_amount || 0),
                                  0
                                )
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      </React.Fragment>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              {/* Unpaid Bookings Table */}
              <TableContainer
                component={Paper}
                sx={{
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    height: 8,
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f1f1f1",
                    borderRadius: 4,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#c1c1c1",
                    borderRadius: 4,
                    "&:hover": {
                      backgroundColor: "#a8a8a8",
                    },
                  },
                }}
              >
                <Table sx={{ minWidth: 1400 }}>
                  <TableHead>
                    <TableRow sx={{ bgcolor: "warning.light" }}>
                      <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Customer</TableCell>
                      <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Order Code</TableCell>
                      <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Date</TableCell>
                      <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Payment Method</TableCell>
                      <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                        Amount Paid
                      </TableCell>
                      <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                        Payable Amount
                      </TableCell>
                      <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                        Balance Due
                      </TableCell>
                      <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Status</TableCell>
                      <TableCell align="center" sx={{ minWidth: 200, whiteSpace: "nowrap" }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading.unpaid ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : filteredUnpaidOrders.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                          <Typography variant="body1" color="text.secondary">
                            {searchQuery ? "No unpaid bookings found matching your search" : "No unpaid bookings found"}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <React.Fragment>
                        {filteredUnpaidOrders.map((transaction) => (
                          <TableRow
                            key={transaction.order_id || transaction.customer_id}
                            sx={{
                              "&:nth-of-type(even)": { bgcolor: "grey.50" },
                              "&:hover": { bgcolor: "action.hover" },
                            }}
                          >
                            {/* Customer Column */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Avatar
                                  sx={{ bgcolor: "#e3f2fd", width: 40, height: 40, mr: 2 }}
                                >
                                  <Person sx={{ fontSize: 20, color: "#1976d2" }} />
                                </Avatar>
                                <Box>
                                  <Typography variant="body2" fontWeight="500">
                                    {transaction.member_name}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {transaction.email || "No email"}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" display="block">
                                    {transaction.phone}
                                  </Typography>
                                </Box>
                              </Box>
                            </TableCell>

                            {/* Order Code */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2" sx={{ fontWeight: "bold", color: "primary.main" }}>
                                {transaction.order_code || "N/A"}
                              </Typography>
                            </TableCell>

                            {/* Date */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2">
                                {transaction.order_date ? formatDate(transaction.order_date) : "N/A"}
                              </Typography>
                            </TableCell>

                            {/* Payment Method */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Chip
                                label={transaction.mode_of_payment || "N/A"}
                                size="small"
                                color="secondary"
                              />
                            </TableCell>

                            {/* Amount Paid */}
                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2" color="error.main">
                                {formatCurrency(transaction.amount_paid || "0")}
                              </Typography>
                            </TableCell>

                            {/* Payable Amount */}
                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2">
                                {formatCurrency(transaction.payable_amount || "0")}
                              </Typography>
                            </TableCell>

                            {/* Balance Due */}
                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: "bold",
                                  color: getOutstandingColor2(Number(transaction.balance_due || 0)),
                                }}
                              >
                                {formatCurrencyN(Number(transaction.balance_due))}
                              </Typography>
                            </TableCell>

                            {/* Status */}
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                <Chip
                                  label="UNPAID"
                                  size="small"
                                  color="error"
                                  sx={{ width: "fit-content" }}
                                />
                                {transaction.order_status && (
                                  <Chip
                                    label={transaction.order_status}
                                    size="small"
                                    color={getOrderStatusColor(transaction.order_status) as any}
                                    sx={{ width: "fit-content" }}
                                  />
                                )}
                              </Box>
                            </TableCell>

                            {/* Actions */}
                            <TableCell align="center">
                              <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                                {/* Process Button */}
                                <Tooltip title="Process Customer Payment">
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<AttachMoney />}
                                    onClick={() => handleCustomerSelect(transaction)}
                                    color="warning"
                                  >
                                    Process
                                  </Button>
                                </Tooltip>

                                <Tooltip title="View Order Details">
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color="info"
                                    startIcon={<Visibility />}
                                    onClick={() => viewTransactionDetail(transaction)}
                                  >
                                    View
                                  </Button>
                                </Tooltip>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}

                        {/* Footer with Totals */}
                        <TableRow sx={{ backgroundColor: "grey.200" }}>
                          <TableCell colSpan={5} align="right">
                            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                              Totals
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                              {formatCurrency(
                                filteredUnpaidOrders.reduce(
                                  (sum, tx) => sum + Number(tx.payable_amount || 0),
                                  0
                                )
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1" sx={{ fontWeight: "bold", color: "error.main" }}>
                              {formatCurrencyN(
                                filteredUnpaidOrders.reduce(
                                  (sum, tx) => sum + Number(tx.balance_due || 0),
                                  0
                                )
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      </React.Fragment>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </TabPanel>

            {/* Results Summary */}
            <Alert
              severity={tabValue === 0 ? "success" : "warning"}
              sx={{
                mt: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <Box>
                Showing {currentOrders.length} {tabValue === 0 ? "paid" : "unpaid"} bookings
                {filters.paymentMethod && filters.paymentMethod !== "All" && (
                  <span> • Filtered by: {filters.paymentMethod}</span>
                )}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress
                  size={16}
                  thickness={autoRefreshEnabled ? 4 : 2}
                  color={autoRefreshEnabled ? "primary" : "inherit"}
                />
                <Typography variant="caption">
                  Auto-refresh: {autoRefreshEnabled ? "ON" : "OFF"}
                </Typography>
              </Box>
            </Alert>
          </Box>

          {/* ENHANCED VERIFICATION DIALOG - MATCHING FIRST COMPONENT */}
          {/* ... (Keep existing verify dialog code) */}

          {/* MODIFIED: Transaction Detail Dialog with Loading State - FROM SECOND COMPONENT */}
          <Dialog
            open={showTransactionDetail}
            onClose={closeTransactionDetail}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">
                  {loadingDetails ? "Loading Order Details..." : `Order Details - ${selectedTransaction?.order_code}`}
                </Typography>
                <IconButton onClick={closeTransactionDetail}>
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>

            {loadingDetails && <LinearProgress />}

            <DialogContent dividers>
              {loadingDetails ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
                  <CircularProgress />
                  <Typography sx={{ ml: 2 }}>Fetching order breakdown...</Typography>
                </Box>
              ) : detailsError ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
                  <ErrorIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
                  <Typography color="error" gutterBottom>
                    Error Loading Details
                  </Typography>
                  <Typography variant="body2" color="text.secondary" align="center">
                    {detailsError}
                  </Typography>
                  <Button
                    variant="outlined"
                    onClick={() => selectedTransaction && fetchOrderDetails(selectedTransaction.order_id || "", selectedTransaction.branch_id)}
                    sx={{ mt: 2 }}
                  >
                    Retry
                  </Button>
                </Box>
              ) : orderDetails ? (
                // Order Details Content - UPDATED FOR YOUR API RESPONSE
                <Grid container spacing={3}>
                  {/* Order Summary Section */}
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Order Summary
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6} md={4}>
                        <Typography variant="body2" color="text.secondary">Order ID</Typography>
                        <Typography variant="body1" fontWeight="bold">
                          {selectedTransaction?.order_id || orderDetails.items[0]?.order_id}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Typography variant="body2" color="text.secondary">Order Code</Typography>
                        <Typography variant="body1">
                          {selectedTransaction?.order_code || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Typography variant="body2" color="text.secondary">Customer</Typography>
                        <Typography variant="body1">
                          {selectedTransaction?.member_name || selectedTransaction?.customer_name || 'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                  </Grid>

                  {/* Order Items Section */}
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Order Items ({orderDetails.items.length})
                    </Typography>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Product Name</TableCell>
                          <TableCell align="right">Qty</TableCell>
                          <TableCell align="right">Unit Price</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orderDetails.items.map((item, index) => (
                          <TableRow key={item.product_id || index}>
                            <TableCell>
                              <Typography fontWeight="medium">{item.product_name || item.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                ID: {item.product_id}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography>{item.quantity}</Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography>{formatCurrency(item.price)}</Typography>
                              {item.cost_price && (
                                <Typography variant="caption" color="text.secondary" display="block">
                                  Cost: {formatCurrency(item.cost_price)}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell align="right" fontWeight="bold">
                              <Typography>{formatCurrency(item.total_amount)}</Typography>
                              {item.cost_price && (
                                <Typography variant="caption" color="success.main" display="block">
                                  Profit: {formatCurrency((parseFloat(item.quantity) * parseFloat(item.price)) - (parseFloat(item.quantity) * parseFloat(item.cost_price)))}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={item.item_status || item.status || 'N/A'}
                                size="small"
                                color={item.item_status === 'COMPLETED' ? 'success' : 'default'}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TableCell colSpan={3}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              Totals
                            </Typography>
                          </TableCell>
                          <TableCell align="right" colSpan={3}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {formatCurrency(
                                orderDetails.items.reduce((sum, item) => sum + parseFloat(item.total_amount || "0"), 0)
                              )}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Total Quantity: {orderDetails.items.reduce((sum, item) => sum + parseFloat(item.quantity || "0"), 0)}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </Grid>

                  {/* Financial Summary Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Financial Summary
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined">
                          <CardContent>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                              Sales Totals
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Gross Sales:</Typography>
                              <Typography fontWeight="bold">
                                {formatCurrency(
                                  orderDetails.items.reduce((sum, item) => sum + (parseFloat(item.quantity || "0") * parseFloat(item.price || "0")), 0)
                                )}
                              </Typography>
                            </Box>
                            <Divider sx={{ my: 1 }} />
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined">
                          <CardContent>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                              Order Information
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Items Count:</Typography>
                              <Typography>{orderDetails.items.length}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Payment Method:</Typography>
                              <Chip
                                label={selectedTransaction?.mode_of_payment || 'N/A'}
                                size="small"
                                color="secondary"
                              />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Order Status:</Typography>
                              <Chip
                                label={selectedTransaction?.order_status || 'N/A'}
                                size="small"
                                color={
                                  selectedTransaction?.order_status === 'COMPLETED' ? 'success' :
                                    selectedTransaction?.order_status === 'PENDING' ? 'warning' : 'default'
                                }
                              />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                              <Typography>Payment Status:</Typography>
                              <Chip
                                label={selectedTransaction?.payment_status === 1 ? "PAID" : selectedTransaction?.payment_status === 0 ? "UNPAID" : "N/A"}
                                size="small"
                                color={selectedTransaction?.payment_status === 1 ? "success" : "error"}
                              />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Item Details Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Item Details
                    </Typography>
                    <Grid container spacing={1}>
                      {orderDetails.items.map((item, index) => (
                        <Grid item xs={12} md={6} key={item.product_id || index}>
                          <Card variant="outlined" sx={{ height: '100%' }}>
                            <CardContent>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
                                <Typography variant="subtitle1" fontWeight="bold">
                                  {item.product_name || item.name}
                                </Typography>
                                <Chip
                                  label={`#${index + 1}`}
                                  size="small"
                                  color="primary"
                                />
                              </Box>
                              <Typography variant="body2" color="text.secondary" paragraph>
                                {item.description || 'No description available'}
                              </Typography>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Product ID:
                                  </Typography>
                                  <Typography variant="caption" fontWeight="medium">
                                    {item.product_id?.substring(0, 12) || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Category:
                                  </Typography>
                                  <Typography variant="caption" fontWeight="medium">
                                    {item.category_id?.substring(0, 8) || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Quantity:
                                  </Typography>
                                  <Typography variant="body2">{item.quantity}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Price:
                                  </Typography>
                                  <Typography variant="body2">{formatCurrency(item.price)}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Cost Price:
                                  </Typography>
                                  <Typography variant="body2">{formatCurrency(item.cost_price || "0")}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Profit Margin:
                                  </Typography>
                                  <Typography variant="body2" color="success.main">
                                    {formatCurrency(
                                      (parseFloat(item.quantity || "0") * parseFloat(item.price || "0")) -
                                      (parseFloat(item.quantity || "0") * parseFloat(item.cost_price || "0"))
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Divider sx={{ my: 1 }} />
                                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="subtitle2">Total:</Typography>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                      {formatCurrency(item.total_amount)}
                                    </Typography>
                                  </Box>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>

                  {/* Metadata Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="caption" color="text.secondary">
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <InfoIcon fontSize="small" />
                        <Box>
                          <div>Fetched {orderDetails.items.length} items for Order ID: {selectedTransaction?.order_id}</div>
                          <div>Transaction Type: {selectedTransaction?.product_id_type}</div>
                          <div>Balance Due: {formatCurrency(selectedTransaction?.balance_due || 0)}</div>
                          <div>Amount Paid: {formatCurrency(selectedTransaction?.amount_paid || 0)}</div>
                        </Box>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Typography color="text.secondary" align="center" sx={{ p: 3 }}>
                  No order details available
                </Typography>
              )}
            </DialogContent>

            <DialogActions>
              <Button onClick={closeTransactionDetail}>Close</Button>
              {orderDetails && (
                <>
                  <Button
                    variant="outlined"
                    startIcon={<Download />}
                    onClick={() => {
                      // Implement export functionality
                      const exportData = {
                        order_id: selectedTransaction?.order_id,
                        order_code: selectedTransaction?.order_code,
                        items: orderDetails.items,
                        totals: {
                          total_amount: orderDetails.items.reduce((sum, item) => sum + parseFloat(item.total_amount || "0"), 0),
                          total_quantity: orderDetails.items.reduce((sum, item) => sum + parseFloat(item.quantity || "0"), 0)
                        },
                        fetched_at: new Date().toISOString()
                      };

                      const dataStr = JSON.stringify(exportData, null, 2);
                      const dataBlob = new Blob([dataStr], { type: 'application/json' });
                      const url = URL.createObjectURL(dataBlob);
                      const link = document.createElement('a');
                      link.href = url;
                      link.download = `order-details-${selectedTransaction?.order_code || selectedTransaction?.order_id}.json`;
                      link.click();
                      URL.revokeObjectURL(url);
                    }}
                  >
                    Export JSON
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<Receipt />}
                    onClick={() => {
                      // Navigate to receipt page or generate receipt
                      if (selectedTransaction) {
                        history.push("/folder/feedback", {
                          order: selectedTransaction,
                          type: tabValue === 0 ? 'paid' : 'unpaid'
                        });
                      }
                    }}
                  >
                    {tabValue === 0 ? "View Receipt" : "Process Payment"}
                  </Button>
                </>
              )}
            </DialogActions>
          </Dialog>

          {/* Image Preview Dialog */}
          <Dialog open={imageDialogOpen} onClose={() => setImageDialogOpen(false)} maxWidth="lg" fullWidth>
            <DialogTitle>
              Image Preview
              <IconButton
                sx={{ position: "absolute", right: 8, top: 8 }}
                onClick={() => setImageDialogOpen(false)}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 400,
                }}
              >
                <img
                  src={`${baseUrl()}${selectedImage}`}
                  alt="Transaction proof"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "70vh",
                    objectFit: "contain",
                    borderRadius: 8,
                  }}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setImageDialogOpen(false)}>Close</Button>
            </DialogActions>
          </Dialog>

          {/* Snackbar for notifications */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
            message={snackbarMessage}
          />
        </IonContent>
      </IonPage>
    </LocalizationProvider>
  );
};

export default ManageOnlineBooking;